import AppSettings from './settings';


export default class Helper {

    static getDefaultNewsId() {
        let params = new URL(document.location).searchParams;

        return params.get("news_id");
    }

    static formatDate(date) {
        return date.toISOString().split('T')[0];
    }
    
    static addDays(date, days) {
        date.setDate(date.getDate() + days);
        return date;
    }
    
    static getImageUrl(id, isThumbnail) {
        var url = AppSettings.apiUrlAssets;
    
        if (id != "" && id != null && id != undefined) {
            url += id;
            /*
            if (isThumbnail) {
                //url += "?key=thumbnail";
            }
            */
        } else {
            url += AppSettings.loadingImageId;
        }
    
        return url;
    }

    static checkItemsApiResponse(response) {
        if (response.errors != undefined) {
            throw response.errors;
        } else if (response.data.length == 0) {
            throw AppSettings.noDataMessage;
        }
    }
}